<template>
    <section id="wrapper">
        <Preloader v-bind:class="{preloader: showPreloader}"></Preloader>
        <div class="login-register">
            <div class="login-box card">
                <div class="card-body">
                    <div v-if="showFailureMessage">
                        <h4 class="bg-danger text-white text-center p-2 my-2">
                            Registration Failed. Please try again.
                        </h4>
                        <p v-for="error in errors" v-bind:key="error" class="bg-danger text-white text-center p-2 my-2">
                            {{error}}
                        </p>
                    </div>
                    <form class="form-horizontal form-material" id="register_form" @submit.prevent="singUp()">
                        <h3 class="text-center m-b-20">Sign Up</h3>
                        <div class="form-group" :class="{ 'form-group--error': $v.username.$error }">
                            <div class="col-xs-12">
                                <input class="form-control form-control-danger"
                                       :class="{'is-invalid': $v.username.$error}"
                                       name="username"
                                       v-model.trim="$v.username.$model" type="text"
                                       placeholder="Username">
                                <div v-if="$v.username.$error">
                                    <div class="text-danger" v-if="!$v.username.required">Username is required.</div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group ">
                            <div class="col-xs-12">
                                <input class="form-control" :class="{'is-invalid': $v.email.$error}"
                                       name="email"
                                       v-model.trim="$v.email.$model" type="email"
                                       placeholder="Email">
                                <div v-if="$v.email.$error">
                                    <div class="text-danger" v-if="!$v.email.required">Email is required.</div>
                                    <div class="text-danger" v-if="!$v.email.email">Invalid email.</div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group " :class="{ 'form-group--error': $v.password.$error }">
                            <div class="col-xs-12">
                                <input class="form-control" name="password" v-model.trim="$v.password.$model"
                                       type="password"
                                       placeholder="Password">
                                <div v-if="$v.password.$error">
                                    <div class="text-danger" v-if="!$v.password.required">Password is required.</div>
                                    <div class="text-danger" v-if="!$v.password.minLength">
                                        Password must have at least {{$v.password.$params.minLength.min }} letters.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group" :class="{ 'form-group--error': $v.confirmPassword.$error }">
                            <div class="col-xs-12">
                                <input class="form-control" name="confirm_password"
                                       v-model.trim="$v.confirmPassword.$model"
                                       type="password"
                                       placeholder="Confirm Password">
                                <div v-if="$v.confirmPassword.$error">
                                    <div class="text-danger" v-if="!$v.confirmPassword.sameAsPassword">
                                        Passwords must be identical.
                                    </div>
                                    <div class="text-danger" v-if="!$v.confirmPassword.required">
                                        Confirm password is required.
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="form-group row" :class="{ 'form-group--error': $v.terms.$error }">
                            <div class="col-md-12">
                                <div class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input" id="terms" name="terms"
                                           v-model="$v.terms.$model">
                                    <label class="custom-control-label" for="terms">I agree to all <a
                                            href="javascript:void(0)">Terms</a>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="form-group text-center p-b-20 p-t-20">
                            <div class="col-xs-6">
                                <button class="btn btn-info btn-rounded btn-md text-uppercase waves-effect waves-light">
                                    Sign Up
                                </button>
                            </div>
                        </div>
                        <div class="form-group m-b-0">
                            <div class="col-sm-12 text-center">
                                Already have an account?
                                <router-link to="/login" class="text-info m-l-5"><b>Sign In</b></router-link>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import '../../assets/scss/pages/login-register-lock.scss'
    import Preloader from '../Preloader';
    import {required, minLength, email, sameAs} from 'vuelidate/lib/validators';
    import {mapActions, mapState} from 'vuex';
    import AuthService from '../../services/AuthService';

    export default {
        name: 'Register',
        components: {Preloader},
        data() {
            return {
                username: '',
                email: '',
                password: '',
                confirmPassword: '',
                terms: '',
                showFailureMessage: false,
                showPreloader: false,
                errors: {}
            }
        },
        computed: {
            ...mapState({authenticated: state => state.auth.authenticated})
        },
        validations: {
            username: {
                required,
            },
            email: {
                required,
                email
            },
            password: {
                required,
                minLength: minLength(8)
            },
            confirmPassword: {
                required,
                sameAsPassword: sameAs('password')
            },
            terms: {
                required
            }
        },
        methods: {
            ...mapActions(['authenticate']),
            async singUp() {
                this.$v.$touch();
                if (!this.$v.$invalid) {
                    this.showPreloader = true;
                    const data = {
                        username: this.username,
                        email: this.email,
                        password: this.password,
                    };
                    await AuthService.singUp(data).then(response => {
                        if (response.status === 200) {
                            this.$router.push({name: 'login'});
                        } else {
                            this.showPreloader = false;
                        }
                    }).catch((error) => {
                        this.errors = error.response.data.errors;
                        this.showFailureMessage = true;
                        this.showPreloader = false;
                    });
                }
            }
        }
    }
</script>

<style scoped>
    .login-register {
        background-image: url("../../assets/images/background/login-register.jpg");
    }
</style>